import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { GetActiveVendorOwnersState } from "../../models/consumer-admin/get-active-vendor-owners.state";

const initialState: GetActiveVendorOwnersState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerAdminActions.activeVendorOwners.getApi, (state) => ({ ...state, loading: true })),
	on(ConsumerAdminActions.activeVendorOwners.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type"),
		loading: false
	})),
	on(ConsumerAdminActions.activeVendorOwners.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function getActiveVendorOwnersReducer(
	state: GetActiveVendorOwnersState | undefined,
	action: Action
): GetActiveVendorOwnersState {
	return reducer(state, action);
}
